import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import entityActionFactory from './factories/entityActionFactory';
import store from '../reducers/storeRegistration';
import summaryFilterOptionsConstants from '../constants/summaryFilterOptionsConstants';
const entityActions = entityActionFactory('summaryFilterOptions', 'cabinetFilterOptions');

/**
 *  Get the options index query, in the store under summary.<summary identifier>.<filter index>
 */
const getOptionsIndexQuery = (identifier, filterIndex) => {
  var _summaryStore$identif;
  let summaryOptionsIndexQuery = null;
  const summaryStore = store.getState().summaryFilterOptions || {};
  if ((_summaryStore$identif = summaryStore[identifier]) !== null && _summaryStore$identif !== void 0 && _summaryStore$identif[filterIndex]) {
    summaryOptionsIndexQuery = summaryStore[identifier][filterIndex].indexQuery;
  }

  // if not initialized, set the options index query to the base summary.initialIndexQuery
  if (summaryStore && !summaryOptionsIndexQuery) {
    summaryOptionsIndexQuery = _objectSpread(_objectSpread({}, summaryStore.initialIndexQuery), {}, {
      identifier,
      filterIndex
    });
  }
  return summaryOptionsIndexQuery;
};

/**
 *  Pull out the filter option's indexQuery from summaryFilterOptions state and call entityActions
 */
const pageNext = (identifier, filterIndex) => async dispatch => {
  const hasNext = store.getState().summaryFilterOptions[identifier][filterIndex].hasNext;
  if (hasNext) {
    const summaryOptionsIndexQuery = getOptionsIndexQuery(identifier, filterIndex);
    await dispatch(entityActions.pageNext(summaryOptionsIndexQuery));
  }
};

/**
 *  Store the current summary and filter in state, which can be read by the index
 *  success reducer to put data in the proper place
 */
const setCurrentSummaryFilter = (currentSummary, currentFilter) => ({
  type: summaryFilterOptionsConstants.SET_CURRENT,
  currentSummary,
  currentFilter
});
const serverFilter = (identifier, filterIndex, filters) => async dispatch => {
  if (!identifier || !filterIndex) return null;
  dispatch(setCurrentSummaryFilter(identifier, filterIndex));
  const summaryOptionsIndexQuery = getOptionsIndexQuery(identifier, filterIndex);
  await dispatch(entityActions.serverFilter(filters, summaryOptionsIndexQuery));
  return null;
};
const summaryFilterOptionsActions = {
  pageNext,
  serverFilter
};
export default summaryFilterOptionsActions;